import { forEach } from "lodash";
import { $Qll } from "../utils/query-selector";

/**
 * Load events on accordion tabs 
 * to change tab state when using tabs on desktop.
 * 
 * @returns void
 */
export function loadTabsEvents() {
  const accordions = $Qll('.accordion-tabs');
  
  if(!accordions) return;

  accordions.forEach(accordion => {
    const tabs = $Qll('.accordion-tab', accordion);
    const buttons = $Qll('.accordion-item__button', accordion);

    tabs.forEach(tab => {
      tab.addEventListener('click', ({ target }) => {
        let selectedTab = validateSelectedElement(target);
        
        triggerTab(selectedTab, tabs, buttons)
      })
    });

    buttons.forEach(button => {
      button.addEventListener('click', ({ target }) => {
        let selectedButton = validateSelectedElement(target);

        const selectedButtonKey = findKeyTab(selectedButton, buttons);

        tabs.forEach((tab, index) => {
          if(index == selectedButtonKey) {
            tab.dataset.active = true;
            buttons[index].dataset.active = true;
          } else {
            tab.dataset.active = false;
            buttons[index].dataset.active = false;
          }
        });
      })
    })
  });
}

/**
 * Change the active param of tabs elements.
 * 
 * @param {NodeElement} selectedTab 
 * @param {NodeList} tabs 
 * @param {NodeList} buttons 
 */
function triggerTab(selectedTab, tabs, buttons) {
  const selectedTabKey = findKeyTab(selectedTab, tabs);

  tabs.forEach((tab, index) => {
    if(index == selectedTabKey) {
      tab.dataset.active = true;
      buttons[index].dataset.active = true;
    } else {
      tab.dataset.active = false;
      buttons[index].dataset.active = false;
    }
  });
}


/**
 * Get index of list tabs.
 * 
 * @param {NodeElement} selectedTab 
 * @param {NodeList} tabs 
 * @returns {Integer} key
 */
function findKeyTab(selectedTab, tabs) {
  let keyResult = 0;

  tabs.forEach((tab, index) => {
    if(tab == selectedTab) {
      keyResult = index;
    }
  });

  return keyResult;
}

/**
 * Get the button parent element when was clicked the span element.
 * 
 * @param {NodeElement} element 
 * @returns {NodeElement} element
 */
function validateSelectedElement(element) {
  if(element.tagName === "SPAN") {
    return element.parentNode;
  }

  return element;
}